// extracted by mini-css-extract-plugin
export var csatScore = "_j9-5";
export var header = "_j9-1";
export var panelWrapper = "_j9-2";
export var postPreview = "_j9-3";
export var rightContent = "_j9-0";
export var wrappingText = "_j9-4";